import { Box, Breadcrumbs, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CustomerMasterForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    // General Data
    accountGroup: "ZDOM",
    title: "",
    name1: "",
    name2: "",
    name3: "",
    searchTerm1: "",
    searchTerm2: "",

    // Address & Contact
    street: "",
    houseNumber: "",
    street2: "",
    street3: "",
    district: "",
    cityName: "",
    postalCode: "",
    country: "IN",
    region: "",
    language: "EN",
    mobile1: "",
    telephone: "",
    mobile2: "",
    email1: "",
    email2: "",
    fax: "",

    // ID Documents
    idType: "AADHAR",
    aadharNo: "",
    drivingLicenceNo: "",
    passportNo: "",
    voterIdNo: "",
    electricBillNo: "",
    gstNumber: "",
    serialRegistrationNo: "",

    // Bank Details
    bankDetailsId: "0001",
    bankCountry: "IN",
    bankKey: "",
    bankAccount: "",
    accountHolderName: "",

    // Sales Data
    salesOrg: "1000",
    distributionChannel: "40",
    division: "17/99",
    salesDistrict: "491441",
    salesOffice: "1022",
    salesGroup: "IN1",
    currency: "INR",
    exchangeRateType: "M",
    priceGroup: "A1",
    custPricingProcedure: "1",
    custStatsGrp: "1",
    deliverPriority: "1",
    settlementManagement: true,
    orderCombination: true,
    shippingCondition: "01",
    podRelevant: true,
    pricing: true,
    incoTerms: "Exw",
    incoLocation1: "City",
    paymentTerms: "C001",
    creditControlArea: "1017",
    accAssigment: "01",
    taxClassificationGST: "0/1",
    taxClassification: "0",

    // Company
    comapnyCode: "1000",
    reconciliationAc: "27000010",
    sortKey: "001",
    paymentTerms: "C001",
    checkDuplicateInvoices: true,
    clerkAbbreviation: "E1",
    panNumber: "",
    serialRegistrationNumber: "",
    recordPaymentHistory: true,
    notes: "",

    //Credit
    limitRule: "B2B-New",
    riskClass: "Z01",
    checkRule: "Z0001",
    creditSegment: "1017",
    creditGroup: "1",
  });

  const totalSteps = 7;

  // This covers formatting, checkboxes, and auto-updates other fields
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let processedValue = value;

    // Special formatting by field name
    if (name === "aadharNo") {
      processedValue = value.replace(/\D/g, "").substring(0, 12);
    } else if (name === "panNumber") {
      processedValue = value.toUpperCase().substring(0, 10);
    } else if (["mobile1", "mobile2", "telephone"].includes(name)) {
      processedValue = value.replace(/\D/g, "").substring(0, 10);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : processedValue,
      // Also update searchTerm2 automatically when searchTerm1 changes
      ...(name === "searchTerm1" ? { searchTerm2: processedValue } : {}),
    }));
  };

  const validateCurrentStep = () => {
    const requiredFields = {
      1: ["title", "name1", "searchTerm1"],
      2: ["street", "district", "cityName", "postalCode", "region", "mobile1"],
      3: ["aadharNo", "panNumber"],
      4: [], // No required fields in bank details
      5: [
        "incoLocation1",
        "division",
        "creditControlArea",
        "taxClassificationGST",
      ],
      6: [], // No required fields in company data
    };
    console.log(currentStep, "currentStep");
    const fieldsToCheck = requiredFields[currentStep] || [];
    console.log(fieldsToCheck, "fieldsToCheck");
    for (let field of fieldsToCheck) {
      if (!formData[field] || formData[field].toString().trim() === "") {
        return false;
      }
    }
    return true;
  };

  const nextStep = () => {
    setCurrentStep((prev) => prev + 1);
    // if (validateCurrentStep() && currentStep < totalSteps) {
    //   setCurrentStep((prev) => prev + 1);
    // } else if (!validateCurrentStep()) {
    //   alert("Please fill in all required fields before proceeding.");
    // }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateCurrentStep()) {
      console.log("Customer Data:", formData);
      alert(
        "Customer master data submitted successfully!\n\nThank you for completing the registration process."
      );

      // Reset form
      setFormData({
        // General Data
        accountGroup: "ZDOM",
        title: "",
        name1: "",
        name2: "",
        name3: "",
        searchTerm1: "",
        searchTerm2: "",

        // Address & Contact
        street: "",
        houseNumber: "",
        street2: "",
        street3: "",
        district: "",
        cityName: "",
        postalCode: "",
        country: "IN",
        region: "",
        language: "EN",
        mobile1: "",
        telephone: "",
        mobile2: "",
        email1: "",
        email2: "",
        fax: "",

        // ID Documents
        idType: "AADHAR",
        aadharNo: "",
        drivingLicenceNo: "",
        passportNo: "",
        voterIdNo: "",
        electricBillNo: "",
        gstNumber: "",
        serialRegistrationNo: "",

        // Bank Details
        bankDetailsId: "0001",
        bankCountry: "IN",
        bankKey: "",
        bankAccount: "",
        accountHolderName: "",

        // Sales Data
        salesOrg: "1000",
        distributionChannel: "40",
        division: "17/99",
        salesDistrict: "491441",
        salesOffice: "1022",
        salesGroup: "IN1",
        currency: "INR",
        exchangeRateType: "M",
        priceGroup: "A1",
        custPricingProcedure: "1",
        custStatsGrp: "1",
        deliverPriority: "1",
        settlementManagement: true,
        orderCombination: true,
        shippingCondition: "01",
        podRelevant: true,
        pricing: true,
        incoTerms: "Exw",
        incoLocation1: "City/District",
        paymentTerms: "C001",
        creditControlArea: "1017/1099",
        accAssigment: "01",
        taxClassificationGST: "0/1",
        taxClassification: "0",

        // Company & Credit
        comapnyCode: "1000",
        reconciliationAc: "27000010",
        sortKey: "001",
        paymentTerms: "C001",
        checkDuplicateInvoices: true,
        clerkAbbreviation: "E1",
        panNumber: "",
        serialRegistrationNumber: "",
        recordPaymentHistory: true,
        notes: "",
      });
      setCurrentStep(1);
    }
  };

  const FormField = ({
    label,
    name,
    type = "text",
    required = false,
    options = null,
    maxLength,
    placeholder,
    hint,
    formData,
    handleInputChange,
  }) => (
    <div className="flex flex-col">
      <label
        className={`font-semibold text-gray-600 mb-2 text-sm ${
          required
            ? "after:content-['_*'] after:text-red-500 after:font-bold"
            : ""
        }`}
      >
        {label}
      </label>
      {type === "select" ? (
        <select
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
          required={required}
          className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
        >
          <option value="">Select {label}</option>
          {options &&
            options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
        </select>
      ) : type === "textarea" ? (
        <textarea
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
          required={required}
          maxLength={maxLength}
          placeholder={placeholder}
          rows={4}
          className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
        />
      ) : type === "checkbox" ? (
        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            name={name}
            checked={formData[name]}
            onChange={handleInputChange}
            className="w-5 h-5 text-green-500 rounded focus:ring-green-500"
          />
          <span className="text-gray-700">{label}</span>
        </div>
      ) : (
        <input
          type={type}
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
          required={required}
          maxLength={maxLength}
          placeholder={placeholder}
          className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
        />
      )}
      {hint && <div className="text-sm text-gray-500 mt-1 italic">{hint}</div>}
    </div>
  );

  const StepIndicator = ({ step, label, isActive, isCompleted }) => (
    <div
      className={`flex items-center gap-3 text-sm transition-all duration-300 ${
        isActive
          ? "text-green-500 font-semibold"
          : isCompleted
          ? "text-green-600"
          : "text-gray-500"
      }`}
    >
      <span
        className={`w-8 h-8 rounded-full flex items-center justify-center font-bold transition-all duration-300 ${
          isActive
            ? "bg-green-500 text-white"
            : isCompleted
            ? "bg-green-600 text-white"
            : "bg-gray-200"
        }`}
      >
        {step}
      </span>
      <span className="hidden sm:block">{label}</span>
    </div>
  );

  const progressPercentage = (currentStep / totalSteps) * 100;

  const handleClick = () => {};

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={{ px: { xs: 1, sm: 1 } }}
        >
          <Link
            underline="hover"
            key="1"
            color="inherit"
            to="/dashboard"
            onClick={handleClick}
          >
            Home
          </Link>
          <Link
            underline="hover"
            key="2"
            color="inherit"
            to="/mdm-list"
            onClick={handleClick}
          >
            Customer Code Request
          </Link>
          <Typography key="3" color="primary">
            Customer Code Details
          </Typography>
        </Breadcrumbs>
      </Box>

      <div className="min-h-screen p-5"> 
        <div className="max-w-8xl mx-auto bg-white/95 rounded-3xl shadow-2xl backdrop-blur-sm overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-green-500 to-green-600 text-white p-8 text-center">
            <h1 className="text-4xl font-light mb-3">Customer Master Data</h1>
            <p className="text-xl opacity-90">
              Complete customer registration in simple steps
            </p>
          </div>

          {/* Progress Bar */}
          <div className="h-1 bg-gray-200">
            <div
              className="h-full bg-gradient-to-r from-green-500 to-green-600 transition-all duration-500 rounded-r"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>

          {/* Step Navigation */}
          <div className="flex flex-wrap justify-between p-6 bg-gray-50 border-b border-gray-200 gap-4">
            <StepIndicator
              step={1}
              label="General Info"
              isActive={currentStep === 1}
              isCompleted={currentStep > 1}
            />
            <StepIndicator
              step={2}
              label="Address & Contact"
              isActive={currentStep === 2}
              isCompleted={currentStep > 2}
            />
            <StepIndicator
              step={3}
              label="ID Documents"
              isActive={currentStep === 3}
              isCompleted={currentStep > 3}
            />
            <StepIndicator
              step={4}
              label="Bank Details"
              isActive={currentStep === 4}
              isCompleted={currentStep > 4}
            />
            <StepIndicator
              step={5}
              label="Sales Data"
              isActive={currentStep === 5}
              isCompleted={currentStep > 5}
            />
            <StepIndicator
              step={6}
              label="Company Data"
              isActive={currentStep === 6}
              isCompleted={currentStep > 6}
            />
            <StepIndicator
              step={7}
              label="Credit Segment"
              isActive={currentStep === 7}
              isCompleted={currentStep > 7}
            />
          </div>

          <div className="p-10">
            {/* Step 1: General Information */}
            {currentStep === 1 && (
              <div className="animate-fadeIn">
                <h2 className="text-3xl text-gray-800 mb-8 pb-3 border-b-4 border-green-500">
                  General Information
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                    >
                      Account Group
                    </label>
                    <select
                      name="accountGroup"
                      value={formData["accountGroup"]}
                      onChange={handleInputChange}
                      required
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    >
                      <option value="">Select Account Group</option>
                      <option value="ZDOM">ZDOM</option>
                    </select>
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                    >
                      Title
                    </label>
                    <select
                      name="title"
                      value={formData["title"]}
                      onChange={handleInputChange}
                      required
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    >
                      <option value="">Select Title</option>
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Ms">Ms</option>
                      <option value="Dr">Dr</option>
                    </select>
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                    >
                      Name 1
                    </label>
                    <input
                      type="text"
                      name="name1"
                      value={formData["name1"]}
                      onChange={handleInputChange}
                      required
                      maxLength="50"
                      placeholder={"Enter firm name"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Name 2
                    </label>
                    <input
                      type="text"
                      name="name2"
                      value={formData["name2"]}
                      onChange={handleInputChange}
                      maxLength="40"
                      placeholder={"Additional name"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Name 3
                    </label>
                    <input
                      type="text"
                      name="name3"
                      value={formData["name3"]}
                      onChange={handleInputChange}
                      maxLength="40"
                      placeholder={"e.g., Sandeep Kumar Gajpal"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                    >
                      Search Term 1
                    </label>
                    <input
                      type="text"
                      name="searchTerm1"
                      value={formData["searchTerm1"]}
                      onChange={handleInputChange}
                      required
                      maxLength="20"
                      placeholder={"e.g., Parivartan"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                    >
                      Search Term 2
                    </label>
                    <input
                      type="text"
                      name="searchTerm2"
                      value={formData["searchTerm2"]}
                      onChange={handleInputChange}
                      required
                      maxLength="20"
                      placeholder={"e.g., Parivartan"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Step 2: Address & Contact */}
            {currentStep === 2 && (
              <div className="animate-fadeIn">
                <h2 className="text-3xl text-gray-800 mb-8 pb-3 border-b-4 border-green-500">
                  Address & Contact Information
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                    >
                      Street
                    </label>
                    <input
                      type="text"
                      name="street"
                      value={formData["street"]}
                      onChange={handleInputChange}
                      required
                      maxLength="60"
                      placeholder={"Enter street address"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                    <div className="text-sm text-gray-500 mt-1 italic">
                      Aadhar Address preferred
                    </div>
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      House Number
                    </label>
                    <input
                      type="text"
                      name="houseNumber"
                      value={formData["houseNumber"]}
                      onChange={handleInputChange}
                      maxLength="40"
                      placeholder={"House/Building number"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Street 2
                    </label>
                    <input
                      type="text"
                      name="street2"
                      value={formData["street2"]}
                      onChange={handleInputChange}
                      maxLength="40"
                      placeholder={"Additional address line"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Street 3
                    </label>
                    <input
                      type="text"
                      name="street3"
                      value={formData["street3"]}
                      onChange={handleInputChange}
                      maxLength="40"
                      placeholder={"Additional address line"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      District
                    </label>
                    <input
                      type="text"
                      name="district"
                      value={formData["district"]}
                      onChange={handleInputChange}
                      required
                      maxLength="40"
                      placeholder={"e.g., Durg"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Postal Code
                    </label>
                    <input
                      type="text"
                      name="postalCode"
                      value={formData["postalCode"]}
                      onChange={handleInputChange}
                      maxLength="20"
                      placeholder={"e.g., 491001"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      City Name
                    </label>
                    <input
                      type="text"
                      name="cityName"
                      value={formData["cityName"]}
                      onChange={handleInputChange}
                      required
                      maxLength="40"
                      placeholder={"e.g., Durg"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Country
                    </label>
                    <input
                      type="text"
                      name="country"
                      value={formData["country"]}
                      required
                      maxLength="2"
                      placeholder={"IN"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Region
                    </label>
                    <select
                      name="region"
                      value={formData["region"]}
                      onChange={handleInputChange}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    >
                      <option value="">Select State Code</option>
                      <option value="22">Chhattisgarh (22)</option>
                      <option value="01">Andhra Pradesh (01)</option>
                      <option value="12">Karnataka (12)</option>
                    </select>
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Language
                    </label>
                    <input
                      type="text"
                      name="language"
                      value={formData["language"]}
                      required
                      maxLength="2"
                      placeholder={"EN"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Telephone
                    </label>
                    <input
                      type="tel"
                      name="mobile1"
                      value={formData["mobile1"]}
                      onChange={handleInputChange}
                      maxLength="30"
                      placeholder={"e.g., 9109902477"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Mobile Number 1
                    </label>
                    <input
                      type="tel"
                      name="telephone"
                      value={formData["telephone"]}
                      onChange={handleInputChange}
                      maxLength="30"
                      placeholder={"e.g., 9109902477"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Mobile Number 2
                    </label>
                    <input
                      type="tel"
                      name="mobile2"
                      value={formData["mobile2"]}
                      onChange={handleInputChange}
                      maxLength="30"
                      placeholder={"Alternate mobile number"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Email Address 1
                    </label>
                    <input
                      type="email"
                      name="email1"
                      value={formData["email1"]}
                      onChange={handleInputChange}
                      maxLength="135"
                      placeholder={"primary@email.com"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Email Address 2
                    </label>
                    <input
                      type="email"
                      name="email2"
                      value={formData["email2"]}
                      onChange={handleInputChange}
                      maxLength="135"
                      placeholder={"secondary@email.com"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Fax Number
                    </label>
                    <input
                      type="number"
                      name="fax"
                      value={formData["fax"]}
                      onChange={handleInputChange}
                      maxLength="30"
                      placeholder={"Fax number"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Step 3: ID Documents */}
            {currentStep === 3 && (
              <div className="animate-fadeIn">
                <h2 className="text-3xl text-gray-800 mb-8 pb-3 border-b-4 border-green-500">
                  ID Documents
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                    >
                      ID Type
                    </label>
                    <select
                      name="idType"
                      value={formData["idType"]}
                      onChange={handleInputChange}
                      required
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    >
                      <option value="">Select ID Type</option>
                      <option value="AADHAR">Aadhar</option>
                      <option value="Driving License">Driving License</option>
                      <option value="Passport">Passport</option>
                      <option value="Voter ID">Voter ID</option>
                      <option value="Electric Bill">Electric Bill</option>
                      <option value="GST Number">GST Number</option>
                    </select>
                  </div>

                  {formData["idType"] === "AADHAR" && (
                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                      >
                        Aadhar Number
                      </label>
                      <input
                        type="text"
                        name="aadharNo"
                        value={formData["aadharNo"]}
                        onChange={handleInputChange}
                        required
                        maxLength="12"
                        placeholder={"0000-0000-0000"}
                        className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                      />
                      <div className="text-sm text-gray-500 mt-1 italic">
                        12-digit Aadhar number
                      </div>
                    </div>
                  )}

                  {formData["idType"] === "Driving License" && (
                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm `}
                      >
                        Driving Licence Number
                      </label>
                      <input
                        type="text"
                        name="drivingLicenceNo"
                        value={formData["drivingLicenceNo"]}
                        onChange={handleInputChange}
                        maxLength="15"
                        placeholder={"Driving Licence Number"}
                        className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                      />
                    </div>
                  )}

                  {formData["idType"] === "Passport" && (
                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm `}
                      >
                        Passport Number
                      </label>
                      <input
                        type="text"
                        name="passportNo"
                        value={formData["passportNo"]}
                        onChange={handleInputChange}
                        maxLength="15"
                        placeholder={"Passport Number"}
                        className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                      />
                    </div>
                  )}

                  {formData["idType"] === "Voter ID" && (
                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm `}
                      >
                        Voter ID Number
                      </label>
                      <input
                        type="text"
                        name="voterIdNo"
                        value={formData["voterIdNo"]}
                        onChange={handleInputChange}
                        maxLength="15"
                        placeholder={"Voter ID Number"}
                        className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                      />
                    </div>
                  )}

                  {formData["idType"] === "Electric Bill" && (
                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm `}
                      >
                        Electric Bill Number
                      </label>
                      <input
                        type="text"
                        name="electricBillNo"
                        value={formData["electricBillNo"]}
                        onChange={handleInputChange}
                        maxLength="15"
                        placeholder={"Electric bill number"}
                        className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                      />
                    </div>
                  )}

                  {formData["idType"] === "GST Number" && (
                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm `}
                      >
                        GST Number
                      </label>
                      <input
                        type="text"
                        name="gstNumber"
                        value={formData["gstNumber"]}
                        onChange={handleInputChange}
                        maxLength="15"
                        placeholder={"e.g., CGTU234567890"}
                        className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Step 4: Bank Details */}
            {currentStep === 4 && (
              <div className="animate-fadeIn">
                <h2 className="text-3xl text-gray-800 mb-8 pb-3 border-b-4 border-green-500">
                  Bank Details
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Bank Details ID
                    </label>
                    <input
                      type="text"
                      name="bankDetailsId"
                      value={formData["bankDetailsId"]}
                      onChange={handleInputChange}
                      maxLength="4"
                      placeholder={"0001"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Bank Country
                    </label>
                    <input
                      type="text"
                      name="bankCountry"
                      value={formData["bankCountry"]}
                      maxLength="2"
                      placeholder={"IN"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Bank Key
                    </label>
                    <input
                      type="text"
                      name="bankKey"
                      value={formData["bankKey"]}
                      onChange={handleInputChange}
                      maxLength="11"
                      placeholder={"e.g., SBIN00006995"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Bank Account Number
                    </label>
                    <input
                      type="text"
                      name="bankAccount"
                      value={formData["bankAccount"]}
                      onChange={handleInputChange}
                      maxLength="18"
                      placeholder={"12345678009875"}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Account Holder Name
                    </label>
                    <input
                      type="text"
                      name="accountHolderName"
                      value={formData["accountHolderName"]}
                      onChange={handleInputChange}
                      maxLength="60"
                      placeholder={"Firm/Farmer Name"}
                      className="p-3 border-2 border-gray-200 rounded-lg ml-2 text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                    <div className="text-sm text-gray-500 mt-1 italic">
                      Should match firm name or farmer name
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Step 5: Sales Data */}
            {currentStep === 5 && (
              <div className="animate-fadeIn">
                <h2 className="text-3xl text-gray-800 mb-8 pb-3 border-b-4 border-green-500">
                  Sales Configuration
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Sales Org
                    </label>
                    <input
                      type="text"
                      name="salesOrg"
                      value={formData["salesOrg"]}
                      required
                      maxLength="4"
                      placeholder={"1000"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Distribution Channel
                    </label>
                    <input
                      type="text"
                      name="distributionChannel"
                      value={formData["distributionChannel"]}
                      required
                      maxLength="4"
                      placeholder={"40"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Division
                    </label>
                    <input
                      type="text"
                      name="division"
                      value={formData["division"]}
                      required
                      maxLength="2"
                      placeholder={"17/99"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Sales District
                    </label>
                    <input
                      type="text"
                      name="salesDistrict"
                      value={formData["salesDistrict"]}
                      required
                      maxLength="6"
                      placeholder={"491441"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Sales Office
                    </label>
                    <input
                      type="text"
                      name="salesOffice"
                      value={formData["salesOffice"]}
                      required
                      maxLength="4"
                      placeholder={"1022"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Sales Group
                    </label>
                    <input
                      type="text"
                      name="salesGroup"
                      value={formData["salesGroup"]}
                      required
                      maxLength="3"
                      placeholder={"IN1"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Currency
                    </label>
                    <input
                      type="text"
                      name="currency"
                      value={formData["currency"]}
                      required
                      maxLength="5"
                      placeholder={"INR"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Exchange Rate Type
                    </label>
                    <input
                      type="text"
                      name="exchangeRateType"
                      value={formData["exchangeRateType"]}
                      required
                      maxLength="1"
                      placeholder={"M"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Price Group
                    </label>
                    <input
                      type="text"
                      name="priceGroup"
                      value={formData["priceGroup"]}
                      required
                      maxLength="2"
                      placeholder={"A1"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Customer Pricing Procedure
                    </label>
                    <input
                      type="text"
                      name="custPricingProcedure"
                      value={formData["custPricingProcedure"]}
                      required
                      maxLength="1"
                      placeholder={"1"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Customer Stats Group
                    </label>
                    <input
                      type="text"
                      name="custStatsGrp"
                      value={formData["custStatsGrp"]}
                      required
                      maxLength="1"
                      placeholder={"1"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Delivery Priority
                    </label>
                    <input
                      type="text"
                      name="deliverPriority"
                      value={formData["deliverPriority"]}
                      required
                      maxLength="2"
                      placeholder={"1"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Shipping Conditions
                    </label>
                    <input
                      type="text"
                      name="shippingCondition"
                      value={formData["shippingCondition"]}
                      required
                      maxLength="2"
                      placeholder={"01"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="md:col-span-2 space-y-4">
                    <div className="flex items-center gap-3 ">
                      <input
                        type="checkbox"
                        name={"settlementManagement"}
                        checked={formData["settlementManagement"]}
                        onChange={handleInputChange}
                        className="w-5 h-5 text-green-500 rounded focus:ring-green-500"
                      />
                      <span className="text-gray-700">
                        Relevant for Settlement Management
                      </span>
                    </div>
                    <div className="flex items-center gap-3 ">
                      <input
                        type="checkbox"
                        name={"orderCombination"}
                        checked={formData["orderCombination"]}
                        onChange={handleInputChange}
                        className="w-5 h-5 text-green-500 rounded focus:ring-green-500"
                      />
                      <span className="text-gray-700">Order Combination</span>
                    </div>

                    <div className="flex items-center gap-3">
                      <input
                        type="checkbox"
                        name={"podRelevant"}
                        checked={formData["podRelevant"]}
                        onChange={handleInputChange}
                        className="w-5 h-5 text-green-500 rounded focus:ring-green-500"
                      />
                      <span className="text-gray-700">POD-Relevant</span>
                    </div>

                    <div className="flex items-center gap-3">
                      <input
                        type="checkbox"
                        name={"pricing"}
                        checked={formData["pricing"]}
                        onChange={handleInputChange}
                        className="w-5 h-5 text-green-500 rounded focus:ring-green-500"
                      />
                      <span className="text-gray-700">Pricing</span>
                    </div>
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Incoterms
                    </label>
                    <input
                      type="text"
                      name="incoTerms"
                      value={formData["incoTerms"]}
                      required
                      maxLength="04"
                      placeholder={"Exw"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Incoterms Location
                    </label>
                    <select
                      name="incoLocation1"
                      value={formData["incoLocation1"]}
                      onChange={handleInputChange}
                      required
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    >
                      <option value="">Select Option</option>
                      <option value="City">City</option>
                      <option value="District">District</option>
                    </select>
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Payment Terms
                    </label>
                    <input
                      type="text"
                      name="paymentTerms"
                      value={formData["paymentTerms"]}
                      required
                      maxLength="04"
                      placeholder={"C001"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Credit Control Area
                    </label>
                    <select
                      name="creditControlArea"
                      value={formData["creditControlArea"]}
                      onChange={handleInputChange}
                      required
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    >
                      <option value="">Select Option</option>
                      <option value="1017">1017</option>
                      <option value="1099">1099</option>
                    </select>
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Account Assignment Group Customer
                    </label>
                    <input
                      type="text"
                      name="accAssigment"
                      value={formData["accAssigment"]}
                      required
                      maxLength="2"
                      placeholder={"01"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Tax Classification (GST-OP)
                    </label>
                    <select
                      name="taxClassificationGST"
                      value={formData["taxClassificationGST"]}
                      onChange={handleInputChange}
                      required
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    >
                      <option value="">Select Option</option>
                      <option value="0">0 - If GST applicable</option>
                      <option value="1">1 - If GST not applicable</option>
                    </select>
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                    >
                      Tax Classification (TCS)
                    </label>
                    <input
                      type="text"
                      name="taxClassification"
                      value={formData["taxClassification"]}
                      required
                      maxLength="1"
                      placeholder={"0"}
                      disabled
                      className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Step 6: Company Data */}
            {currentStep === 6 && (
              <div className="animate-fadeIn">
                <h2 className="text-3xl text-gray-800 mb-8 pb-3 border-b-4 border-green-500">
                  Company Code Information
                </h2>
                <div className="grid grid-cols-1 gap-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                      >
                        Company Code
                      </label>
                      <input
                        type="text"
                        name="comapnyCode"
                        value={formData["comapnyCode"]}
                        required
                        maxLength="4"
                        placeholder={"1000"}
                        disabled
                        className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                      >
                        Reconciliation A/c
                      </label>
                      <input
                        type="text"
                        name="reconciliationAc"
                        value={formData["reconciliationAc"]}
                        required
                        maxLength="10"
                        placeholder={"27000010"}
                        disabled
                        className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                      >
                        Sort Key
                      </label>
                      <input
                        type="text"
                        name="sortKey"
                        value={formData["sortKey"]}
                        required
                        maxLength="3"
                        placeholder={"001"}
                        disabled
                        className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                      >
                        Payment Terms
                      </label>
                      <input
                        type="text"
                        name="paymentTerms"
                        value={formData["paymentTerms"]}
                        required
                        maxLength="4"
                        placeholder={"C001"}
                        disabled
                        className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                      >
                        Clerk Abbreviation
                      </label>
                      <input
                        type="text"
                        name="clerkAbbreviation"
                        value={formData["clerkAbbreviation"]}
                        required
                        maxLength="1"
                        placeholder={"X"}
                        className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                      >
                        PAN Number
                      </label>
                      <input
                        type="text"
                        name="panNumber"
                        value={formData["panNumber"]}
                        onChange={handleInputChange}
                        required
                        maxLength="10"
                        placeholder={"AAAGH36GG"}
                        className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                      />
                      <div className="text-sm text-gray-500 mt-1 italic">
                        10 characters PAN number
                      </div>
                    </div>

                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                      >
                        Serial Registration Number
                      </label>
                      <input
                        type="text"
                        name="serialRegistrationNo"
                        value={formData["serialRegistrationNo"]}
                        required
                        maxLength="40"
                        placeholder={"Serial Registration Number"}
                        className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                      />
                    </div>
                  </div>

                  <div className="md:col-span-2 space-y-4">
                    <div className="flex items-center gap-3">
                      <input
                        type="checkbox"
                        name={"checkDuplicateInvoices"}
                        checked={formData["checkDuplicateInvoices"]}
                        onChange={handleInputChange}
                        className="w-5 h-5 text-green-500 rounded focus:ring-green-500"
                      />
                      <span className="text-gray-700">
                        Check Duplicate Invoices
                      </span>
                    </div>

                    <div className="flex items-center gap-3">
                      <input
                        type="checkbox"
                        name={"recordPaymentHistory"}
                        checked={formData["recordPaymentHistory"]}
                        onChange={handleInputChange}
                        className="w-5 h-5 text-green-500 rounded focus:ring-green-500"
                      />
                      <span className="text-gray-700">
                        Record Payment History
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-col">
                    <label
                      className={`font-semibold text-gray-600 mb-2 text-sm `}
                    >
                      Additional Notes
                    </label>
                    <textarea
                      name={"notes"}
                      value={formData["notes"]}
                      onChange={handleInputChange}
                      placeholder={
                        "Any additional information or special instructions..."
                      }
                      rows={4}
                      className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5"
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Step 7: Credit Segment */}
            {currentStep === 7 && (
              <div className="animate-fadeIn">
                <h2 className="text-3xl text-gray-800 mb-8 pb-3 border-b-4 border-green-500">
                  Credit Information
                </h2>
                <div className="grid grid-cols-1 gap-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                      >
                        Limit Rule
                      </label>
                      <input
                        type="text"
                        name="limitRule"
                        value={formData["limitRule"]}
                        required
                        maxLength="10"
                        placeholder={"B2B-New"}
                        disabled
                        className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                      >
                        Risk Class
                      </label>
                      <input
                        type="text"
                        name="riskClass"
                        value={formData["riskClass"]}
                        required
                        maxLength="3"
                        placeholder={"Z01"}
                        disabled
                        className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                      >
                        Check Rule
                      </label>
                      <input
                        type="text"
                        name="checkRule"
                        value={formData["checkRule"]}
                        required
                        maxLength="5"
                        placeholder={"Z0001"}
                        disabled
                        className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold`}
                      >
                        Credit Segment
                      </label>
                      <input
                        type="text"
                        name="creditSegment"
                        value={formData["creditSegment"]}
                        required
                        maxLength="4"
                        placeholder={"1017"}
                        disabled
                        className="p-3 border-2 border-gray-200 rounded-lg text-secondary transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label
                        className={`font-semibold text-gray-600 mb-2 text-sm after:content-['_*'] after:text-red-500 after:font-bold `}
                      >
                        Credit Group
                      </label>
                      <input
                        type="text"
                        name="creditGroup"
                        value={formData["creditGroup"]}
                        required
                        maxLength="1"
                        placeholder={"X"}
                        className="p-3 border-2 border-gray-200 rounded-lg text-base transition-all duration-300 bg-white hover:border-green-500 focus:border-green-500 focus:outline-none focus:shadow-lg focus:shadow-green-100 focus:-translate-y-0.5 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Navigation Buttons */}
            <div className="flex justify-between mt-10 gap-4">
              <button
                type="button"
                onClick={prevStep}
                disabled={currentStep === 1}
                className="px-8 py-3 bg-gray-500 text-white rounded-lg font-semibold uppercase tracking-wide transition-all duration-300 hover:bg-gray-600 hover:-translate-y-1 hover:shadow-xl disabled:bg-gray-300 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none"
              >
                Previous
              </button>

              {currentStep < totalSteps ? (
                <button
                  type="button"
                  onClick={nextStep}
                  className="px-8 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg font-semibold uppercase tracking-wide transition-all duration-300 hover:from-green-600 hover:to-green-700 hover:-translate-y-1 hover:shadow-xl"
                >
                  Next
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="px-8 py-3 bg-gradient-to-r from-green-600 to-teal-500 text-white rounded-lg font-semibold uppercase tracking-wide transition-all duration-300 hover:from-green-700 hover:to-teal-600 hover:-translate-y-1 hover:shadow-xl"
                >
                  Submit Application
                </button>
              )}
            </div>
          </div>
        </div>

        <style jsx>{`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .animate-fadeIn {
            animation: fadeIn 0.5s ease-in;
          }
        `}</style>
      </div>
    </>
  );
};

export default CustomerMasterForm;
